<div class="modus-content-columns container-body">
  <app-route-panel
    *ngIf="(isFullScreenView$ | async) !== true"
  ></app-route-panel>
  <!-- <div class="position-relative h-100"> -->
  <div class="modus-content" style="flex-basis: 50%">
    <div class="map-container">
      <app-trimble-map></app-trimble-map>
      <!-- <app-single-search></app-single-search> -->
      <app-map-routes></app-map-routes>
      <app-map-addstop-marker
        *ngIf="(isMapLoading$ | async) === false"
      ></app-map-addstop-marker>
      <app-trimble-map-controls> </app-trimble-map-controls>
    </div>
  </div>
  <!-- </div> -->
</div>
